import React from "react";
import { Container, Row, Col, Nav, Form, Button, Image } from "react-bootstrap";
import { FaFacebookF, FaTwitter, FaInstagram } from "react-icons/fa";
import { signUp } from "../../services/mailChimpService";
import logo from "../../assets/Footer_Logo.svg";

const Footer = () => {
	const [showThankYou, setShowThankYou] = React.useState(false);

	const handleSubmitEmail = async (email) => {
		try {
			const res = await signUp({ email: email });
			if (res.status == 201) {
				setShowThankYou(true);
			}
		} catch (error) {
			console.log(error);
			setShowThankYou(true);
		}
	};

	return (
		<footer className=" py-3 bg-black text-white">
			<Container className="" style={{ fontSize: "0.7rem" }}>
				<Row className="align-items-center">
					<Col md={2} className="text-md-end text-center">
						<Image src={logo} alt="Logo" className="mb-2" />
					</Col>
					<Col md={6} className="text-md-start text-center">
						<Nav defaultActiveKey="/home" className="flex-column">
							<Nav.Link href="/about" className="pb-1 pt-0 text-info fw-bold">
								About Us
							</Nav.Link>
							<Nav.Link href="/contact" className="pb-1 pt-0 text-info fw-bold">
								Contact Us
							</Nav.Link>
							<Nav.Link
								href="/privacy-policy"
								className="pb-1 pt-0 text-info fw-bold"
							>
								Privacy Policy
							</Nav.Link>
							<Nav.Link
								href="/termsandconditions"
								className="pb-1 pt-0 text-info fw-bold"
							>
								Terms and Conditions
							</Nav.Link>
						</Nav>
					</Col>
					<Col md={4}>
						{/* {showThankYou ? (
							<div className="text-sm-end text-center">
								<h4>Thank you for signing up! </h4>
								<h6> Stay tuned for exciting announcements. </h6>
							</div>
						) : (
							<div className="text-sm-start text-center mt-sm-0 mt-3">
								<h5 className="text-success fw-bold mb-0 pb-0">
									{" "}
									SUBSCRIBE TO OUR NEWSLETTER
								</h5>
								<div className=" mb-2">
									Stay up to date with races, events and results.
								</div>
								<Form
									className="text-sm-end text-center"
									onSubmit={handleSubmitEmail}
								>
									<Form.Group
										controlId="newsletterEmail"
										style={{ fontSize: "0.7rem" }}
									>
										<Form.Control
											type="email"
											placeholder="Enter email"
											style={{ fontSize: "0.7rem" }}
										/>
									</Form.Group>
									<Button
										variant="success"
										type="submit"
										className="mt-2"
										style={{ fontSize: "0.7rem" }}
									>
										Subscribe
									</Button>
								</Form>
							</div>
						)} */}
						<div className="social-icons mt-3 text-sm-end text-center">
							<a
								href="https://www.facebook.com/theridecompanion/"
								className="me-2 text-white"
							>
								<FaFacebookF />
							</a>
							<a
								href="https://twitter.com/ride_companion?lang=en"
								className="me-2 text-white"
							>
								<FaTwitter />
							</a>
							<a
								href="https://www.instagram.com/theracecompanion/"
								className="text-white"
							>
								<FaInstagram />
							</a>
						</div>
					</Col>
				</Row>
				<Row>
					<Col className="text-center py-3">
						© {new Date().getFullYear()} The Race Companion. All Rights
						Reserved.
					</Col>
				</Row>
			</Container>
		</footer>
	);
};

export default Footer;
